import type { HealthResponse, Recall, RecallListResponse } from "../shared/types";

export interface Filters {
  query: string;
  agency: string;
  source: string;
  urgent: string;
}

async function getJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(url, { headers: { Accept: "application/json" }, signal });
  if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
  return (await response.json()) as T;
}

export function getRecalls(filters: Filters, cursor?: string, signal?: AbortSignal): Promise<RecallListResponse> {
  const params = new URLSearchParams({ limit: "30" });
  if (filters.query) params.set("q", filters.query);
  if (filters.agency) params.set("agency", filters.agency);
  if (filters.source) params.set("source", filters.source);
  if (filters.urgent) params.set("urgent", filters.urgent);
  if (cursor) params.set("cursor", cursor);
  return getJson<RecallListResponse>(`/api/v1/recalls?${params}`, signal);
}

export function getCaptionRecalls(signal?: AbortSignal): Promise<RecallListResponse> {
  return getJson<RecallListResponse>("/api/v1/recalls?limit=100", signal);
}

export function getRecall(id: string, signal?: AbortSignal): Promise<Recall> {
  return getJson<Recall>(`/api/v1/recalls/${encodeURIComponent(id)}`, signal);
}

export function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return getJson<HealthResponse>("/api/v1/health", signal);
}
